import api from "../utils/api";

const BASE = "/api/admin/wifi-packages";

export async function getWifiPackages(params = {}) {
  return (await api.get(BASE, { params })).data;
}

export async function getWifiPackage(id) {
  return (await api.get(`${BASE}/${id}`)).data;
}

export async function createWifiPackage(payload) {
  return (await api.post(BASE, payload)).data;
}

export async function updateWifiPackage(id, payload) {
  return (await api.put(`${BASE}/${id}`, payload)).data;
}

export async function deleteWifiPackage(id) {
  return (await api.delete(`${BASE}/${id}`)).data;
}
